













import { Component, Mixins } from "vue-property-decorator";
import { SelectableObjectDrawerBase } from "./base";
import { default as NamedRectangleCoordinatableObjectDrawer } from "./NamedRectangleCoordinatableObjectDrawer.vue";

@Component({
  components: {
    NamedRectangleCoordinatableObjectDrawer,
  },
})
export default class ComboObjectDrawer extends Mixins(SelectableObjectDrawerBase) {}
